export default function() {
    if (this.$store.state.session.token) {
        this.$router.push('/dashboard')
    }
}
